//
// Config for Channels & Sub-connections
//
import { useState, useEffect } from "react";
import { useGlobalContext } from "../../context/global";
import axios from "axios";
import { buildChannelConfig } from "../../helper/channelIntegrattion/channelIntegrattion";
import {
  fetchSetupAccountRefreshTokens,
  hasActiveAccount,
} from "../../helper/channelIntegrattion/amazonAccountStore";

// --- helper function to generate config ---


export const useChannelConfig = () => {
  const { clientData, clientId } = useGlobalContext();
  const [channelConfig, setChannelConfig] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    const fetchClientData = async () => {
      setLoading(true);
      setError(null);

      const baseUrl = `${process.env.REACT_APP_ADS_API}/client/${clientId}/cursor`;

      try {
        const flipkartPromise = axios.get(
          `${baseUrl}?jobs=flipkart_catalog&cursor_objectives=FK_LISTING_CSV_SYNC,FK_STATS_CSV_SYNC&source=flipkart`
        );

        const myntraPromise = axios.get(
          `${baseUrl}?jobs=myntra_catalog&cursor_objectives=MYNTRA_LISTING_CSV_SYNC,MYNTRA_STATS_CSV_SYNC&source=myntra`
        );

        const amazonPromise = axios.get(
          `${baseUrl}?jobs=amazon_catalog&cursor_objectives=AMAZON_LISTING_CSV_SYNC,AMAZON_STATS_CSV_SYNC&source=amazon`
        );

        const [flipkartRes, myntraRes, amazonRes, setupTokensRes] =
          await Promise.allSettled([
            flipkartPromise,
            myntraPromise,
            amazonPromise,
            fetchSetupAccountRefreshTokens(clientId),
          ]);
        if (active) {
          const mergedCursorData = {
            flipkart:
              flipkartRes.status === "fulfilled"
                ? flipkartRes.value.data.data
                : [],
            myntra:
              myntraRes.status === "fulfilled" ? myntraRes.value.data.data : [],
            amazon:
              amazonRes.status === "fulfilled" ? amazonRes.value.data.data : [],
          };
          const setupTokens =
            setupTokensRes.status === "fulfilled" ? setupTokensRes.value : [];
          setChannelConfig(
            buildChannelConfig(clientData, mergedCursorData, clientId, setupTokens)
          );
        }
      } catch (err) {
        if (active) {
          setError(err.message || "Error loading data");
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchClientData();

    return () => {
      active = false;
    };
  }, []);

  const refreshAmazonConnectionStatus = async () => {
    const setupTokens = await fetchSetupAccountRefreshTokens(clientId);
    setChannelConfig((current) =>
      current.map((channel) => {
        if (channel.id !== "amazon") return channel;
        return {
          ...channel,
          subConnections: channel.subConnections.map((sub) => {
            if (sub.id !== "seller" && sub.id !== "vendor") return sub;
            return { ...sub, completed: hasActiveAccount(sub.id, setupTokens) };
          }),
        };
      })
    );
  };

  return { channelConfig, loading, error, refreshAmazonConnectionStatus };
};
